import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const FolderIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_266_405)'>
        <path d='M16.6667 4.99967H10.0001L8.82508 3.82467C8.50842 3.50801 8.08342 3.33301 7.64175 3.33301H3.33341C2.41675 3.33301 1.67508 4.08301 1.67508 4.99967L1.66675 14.9997C1.66675 15.9163 2.41675 16.6663 3.33341 16.6663H16.6667C17.5834 16.6663 18.3334 15.9163 18.3334 14.9997V6.66634C18.3334 5.74967 17.5834 4.99967 16.6667 4.99967ZM15.8334 14.9997H4.16675C3.70841 14.9997 3.33341 14.6247 3.33341 14.1663V7.49967C3.33341 7.04134 3.70841 6.66634 4.16675 6.66634H15.8334C16.2917 6.66634 16.6667 7.04134 16.6667 7.49967V14.1663C16.6667 14.6247 16.2917 14.9997 15.8334 14.9997Z' />
      </g>
      <defs>
        <clipPath id='clip0_266_405'>
          <rect
            width='20'
            height='20'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
);
